<template>
  <div class="thought in-list d-flex flex-sm-column flex-md-row" :class="thoughtClasses">
    <div class="flex-md-grow-1 truncate-overflow-in-children" @click="openThought()">
      <div class="thought-title truncate-overflow">
        <b v-dompurify-html="thought.title"></b>
      </div>
      <div class="thought-description truncate-overflow">
        <small v-dompurify-html="plainTextDescription"></small>
        <br />
      </div>
      <div class="thought-extras truncate-overflow">
        <small v-dompurify-html="'Autor: ' + thought.owner.public_name"></small>
        <small>, {{ formattedDate(UTCtoLocalTime(thought.created)) }}</small>
      </div>
    </div>
    <div class="thought-info">
      <small>
        Beiträge: {{ thought.commentcount }}
        <br />
        <span v-if="thought.last_comment">
          Letzter Beitrag: {{ formattedDate(UTCtoLocalTime(thought.last_comment)) }}
        </span>
      </small>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';

// stores
import { userStore } from '@/store/user-store';
import { domainStore } from '@/store/domain-store';

// composables
import useConverter from '@/composables/general/useConverter';

export default {
  name: 'forum-thought-in-list',
  props: {
    thought: {
      type: Object,
      required: true,
    },
  },
  emit: ['show-thought'],

  setup(props, context) {
    const { formattedDate, UTCtoLocalTime } = useConverter();

    //
    //-----------------COMPUTED------------------
    //
    const isLoggedIn = computed(() => {
      return userStore.isLoggedIn();
    });
    const domainid = computed(() => {
      return domainStore.getState().domainid;
    });
    const plainTextDescription = computed(() => {
      const doc = new DOMParser().parseFromString(props.thought.content, 'text/html');
      const text = doc.body.textContent || '';
      if (text > 140) {
        return text.substring(0, 140) + '...';
      }
      return text;
    });
    const thoughtClasses = computed(() => {
      return {
        ['thought-' + props.thought.id]: true,
      };
    });

    //
    //-----------------METHODS------------------
    //

    function openThought() {
      context.emit('show-thought', { thoughtid: props.thought.id });
    }

    return {
      // REFS

      // COMPUTED
      domainid,
      isLoggedIn,
      plainTextDescription,
      thoughtClasses,

      // METHODS
      openThought,
      formattedDate,
      UTCtoLocalTime,
    };
  },

  components: {},
};
</script>

<style scoped lang="scss">
.thought.in-list {
  padding: 10px;
  border-top: solid 1px #eee;

  &:hover {
    cursor: pointer;
    background-color: rgb(250, 250, 250);
  }
}
.thought-info {
  min-width: 30%;
  width: 30%;
}
.thought-info,
.thought-extras {
  color: #888;
}
</style>
